import { TypedDocumentNode, gql } from '@apollo/client';
import { useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { DailyClaimButton as CoreDailyClaimButton } from '@sorare/core/src/components/rivals/Arena/DailyClaimButton';
import { FOOTBALL_PLAY_RIVALS_WILDCARD } from '@sorare/core/src/constants/routes';
import useQuery from '@sorare/core/src/hooks/graphql/useQuery';

import { DailyClaimDialog } from 'components/rivals/DailyClaimDialog';

import {
  RivalsDailyClaimButtonQuery,
  RivalsDailyClaimButtonQueryVariables,
} from './__generated__/index.graphql';

const ARENA_TICKET_BUTTON_QUERY = gql`
  query RivalsDailyClaimButtonQuery {
    football {
      rivals {
        id
        currentManager {
          id
          remainingArenaRequests
        }
      }
    }
  }
` as TypedDocumentNode<
  RivalsDailyClaimButtonQuery,
  RivalsDailyClaimButtonQueryVariables
>;

export const DailyClaimButton = () => {
  const location = useLocation();
  const [claimDialogOpen, setClaimDialogOpen] = useState(false);
  const inFootballRivals = !!matchPath(
    FOOTBALL_PLAY_RIVALS_WILDCARD,
    location.pathname
  );

  const { data } = useQuery(ARENA_TICKET_BUTTON_QUERY, {
    skip: !inFootballRivals,
  });

  if (!inFootballRivals) {
    return null;
  }

  const { currentManager } = data?.football.rivals || {};

  if (!currentManager) {
    return null;
  }

  return (
    <>
      <CoreDailyClaimButton
        onClick={() => {
          setClaimDialogOpen(true);
        }}
        remainingArenaRequests={currentManager.remainingArenaRequests}
      />
      <DailyClaimDialog
        open={claimDialogOpen}
        onClose={() => {
          setClaimDialogOpen(false);
        }}
      />
    </>
  );
};
